<template>
    <v-container class="d-flex" justify-center >
        <v-layout column justify-center>
            <v-flex d-flex class="text-xs-center">
                <div>
                    <i :class="icon" class="graph-icon" :style="`color: ${color};`"></i>
                    <span class="graph-value" v-if="typeInternal == 'onOff' ">{{(value == 1) ? 'Aan' : 'Uit'}}</span>
                    <span class="graph-value" v-else-if="typeInternal == 'yesNo' ">{{(value == 1) ? 'Ja' : 'Nee'}}</span>
                    <div class="graph-value" v-else>{{value}}
                        <span class="graph-symbol">{{symbol}}</span>
                    </div>
                    
                </div>
                
            </v-flex>            
            <v-flex center class="text-xs-center">
                <h4 class="graph-caption">{{caption}}</h4>
            </v-flex>
        </v-layout>
    </v-container>

</template>
<script>
export default{
    props:{
        value: {
            required: true,
            
        },
        color: {
            type: String,
            default: 'secondary'
        },
        caption: {
            type: String            
        },
        symbol: {
            type: String
        },
        icon: {
            type: String
        },
        typeInternal: {
            type: String,
            default: 'numeric'
        }
    }
}
</script>
<style>
.graph-icon{
    font-size: 3vw;
    color: rgba(0,0,0,0.7);
}
.graph-caption{
    color: rgba(0,0,0,0.7) !important;
    font-weight: 300;
}

.graph-symbol{
    font-size: 1.2vw;
    margin-left: 0.4vw;
    color: rgba(0,0,0,0.7) !important;
}

.graph-value{
    font-size: 2vw;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap; 
    overflow: hidden;
    /* max-width: 1vw; */
    color: rgba(0,0,0,0.7) !important;
}


</style>